import { default as app } from '../app/_default/store'
import { default as auth } from '../domain/auth/store'
import { default as leiloes } from '../domain/leiloes/store'
import { default as chat } from '../domain/chat/store'

export default { app, auth, leiloes, chat }



// WEBPACK FOOTER //
// ./src/store/modules.js